module.exports = __webpack_public_path__ + "media/soundtrack.fd1755b1.mp3";